import { useMutation } from '@apollo/client';
import { SEND_SURVEY_ANSWERS } from '@pass-frontend/common/data-access';

export const useSendSurveyAnswers = () => {
  const [sendSurveyAnswersMutation, { loading }] = useMutation<{
    questionId: string;
    response: string;
    memberId: string;
  }>(SEND_SURVEY_ANSWERS);

  return {
    sendSurveyAnswersMutation: (
      questionId: string,
      response: string,
      memberId: string,
    ) => {
      return sendSurveyAnswersMutation({
        variables: { questionId, response, memberId },
      });
    },
    loading,
  };
};
